import {Deal, DealStatus} from "@irati/types"

export const isDealUnavailable = (deal: Deal) => {
  return deal.status === DealStatus.Unavailable
}
